import React from "react";
import { connect } from "react-redux";
import NavLink from "../router/NavLink";
import MultiLangText from "../multilang/MultiLangText";
import LegalPopUp from "../pages/LegalPopUp";

class Footer extends React.Component {
  constructor() {
    super();

    // list of offices

    this.state = {
      somethingToUpdate: 0,
    };

    this.locationsLineBreakFix = this.locationsLineBreakFix.bind(this);
    this.updateState = this.updateState.bind(this);
  }

  componentDidUpdate() {
    //console.log("Component Did Update");
    this.locationsLineBreakFix();
  }

  updateState() {
    this.setState({ somethingToUpdate: Math.random() * 300 });
  }

  componentDidMount() {
    this.locationsLineBreakFix();
  }

  locationsLineBreakFix() {
    let locations = this.refs.locations.querySelectorAll(".link-wrapper");
    let yPos;

    for (let i = 0; i < locations.length; i++) {
      let top = locations[i].getBoundingClientRect().top;

      if (top > yPos) {
        locations[i - 1].classList.add("last-in-line");
      } else {
        locations[i].classList.remove("last-in-line");
      }

      yPos = top;
    }
  }

  render() {
    return (
      <footer>
        <div className="icons">
          {this.props.optionsData.data.twitter ? (
            <a href={this.props.optionsData.data.twitter} target="_blank">
              <div className="icon twitter"></div>
            </a>
          ) : null}
          {this.props.optionsData.data.instagram ? (
            <a href={this.props.optionsData.data.instagram} target="_blank">
              <div className="icon instagram"></div>
            </a>
          ) : null}
          {this.props.optionsData.data.linkedin ? (
            <a href={this.props.optionsData.data.linkedin} target="_blank">
              <div className="icon linkedin"></div>
            </a>
          ) : null}
        </div>

        <div className="locations" ref="locations">
          {/*}
              {this.props.officesData.data.map((item,index)=>{

                    return <span key={'l'+index}  className="link-wrapper"><NavLink onClick={()=>{this.updateState()}} to={'/offices/'+item.slug} >{item.title.rendered}</NavLink></span>
              })}
              */}

          <span className="link-wrapper">
            <NavLink
              onClick={() => {
                this.updateState();
              }}
              to={"/offices/brunnen"}
            >
              Brunnen
            </NavLink>
          </span>
          <span className="link-wrapper">
            <a href={"https://kastner-budapest.agency/"} target="_blank">
              Budapest
            </a>
          </span>
          <span className="link-wrapper">
            <a href={"https://www.kastner-frankfurt.agency/"} target="_blank">
              Frankfurt
            </a>
          </span>
          <span className="link-wrapper">
            <a href={"https://www.kastner-london.agency/"} target="_blank">
              London
            </a>
          </span>
          <span className="link-wrapper">
            <a href={"https://www.kastner-los-angeles.agency/"} target="_blank">
              Los Angeles
            </a>
          </span>
          <span className="link-wrapper">
            <a href={"https://www.kastner-madrid.agency/"} target="_blank">
              Madrid
            </a>
          </span>
          <span className="link-wrapper">
            <NavLink
              onClick={() => {
                this.updateState();
              }}
              to={"/offices/milan"}
            >
              Milano
            </NavLink>
          </span>
          <span className="link-wrapper">
            <NavLink
              onClick={() => {
                this.updateState();
              }}
              to={"/offices/Oberhofen"}
            >
              Oberhofen
            </NavLink>
          </span>
        </div>

        <div className="legal-links">
          {this.props.optionsData.data.links.map((item, i) => {
            return (
              <LegalPopUp
                key={"l" + i}
                className="legal-pop-up"
                slug={item.link}
              >
                <MultiLangText className="text-inner" text={item.label} />
              </LegalPopUp>
            );
          })}
        </div>
      </footer>
    );
  }
}

const mapStateToProps = (state) => {
  const officesData = state.KastnerStore.officesData;
  const optionsData = state.KastnerStore.optionsData;
  const screenSize = state.ScreenSize.screensize;

  return {
    officesData,
    optionsData,
    screenSize,
  };
};

export default connect(mapStateToProps)(Footer);



// WEBPACK FOOTER //
// ./src/modules/footer/Footer.js